import type { FunctionalComponent as FC } from 'preact';
import { useCallback } from 'preact/compat';

import { CustomScrollView, Separator } from '@vkontakte/vkui';

import { useWidget } from '../../context/WidgetContext';
import type { UploadedFileType } from '../../types/files';

import { AttachFile } from '../AttachFile';

import styles from './styles.module.css';

interface Props {
  files: UploadedFileType[];
  onRemove: (fileName: string) => void;
  onRetryFileUpload: (fileName: string) => void;
}

export const AttachFilesList: FC<Props> = ({ files, onRemove, onRetryFileUpload }) => {
  const { setError } = useWidget();

  // Метод удаления файла из списка
  const handleRemove = useCallback(
    (fileName: string) => {
      return () => {
        setError?.(null);
        onRemove(fileName);
      };
    },
    [onRemove, setError]
  );

  return (
    <>
      <Separator size={4} />
      <div className={styles.filesListWrapper}>
        <CustomScrollView enableHorizontalScroll>
          <div className={styles.list}>
            {files.map((file, index) => (
              <AttachFile
                key={`${file.name}-${index}`}
                className={styles.item}
                onRemove={handleRemove(file.name)}
                onRetryFileUpload={onRetryFileUpload}
                {...file}
              />
            ))}
          </div>
        </CustomScrollView>
      </div>
    </>
  );
};
